import { motion } from "framer-motion";
import { Search, Settings2, FlaskConical, Rocket } from "lucide-react";
import { ChapterHeading, Reveal } from "@/components/Reveal";

const STEPS = [
  { icon: Search, title: "Diagnóstico", text: "Entendemos como seu negócio recebe mensagens, agenda clientes e faz confirmações." },
  { icon: Settings2, title: "Configuração", text: "Configuramos o agente com seus serviços, regras, horários e fluxos." },
  { icon: FlaskConical, title: "Testes", text: "Testamos situações reais até o atendimento funcionar como esperado." },
  { icon: Rocket, title: "Ativação", text: "O agente entra no ar e acompanhamos os primeiros passos da operação." },
];

export default function Implementation() {
  return (
    <section id="implementacao" data-testid="implementation-section" className="relative overflow-hidden bg-petrol py-28 text-white sm:py-36">
      <motion.div
        initial={{ opacity: 0, rotate: -12, y: -60 }}
        whileInView={{ opacity: 1, rotate: -8, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        className="pointer-events-none absolute -left-24 top-10 h-72 w-52 rounded-[32px] bg-turquoise/10 backdrop-blur-[2px] ring-1 ring-white/5"
      />
      <motion.div
        initial={{ opacity: 0, rotate: 20, y: 60 }}
        whileInView={{ opacity: 1, rotate: 14, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.4, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        className="pointer-events-none absolute -right-16 bottom-0 h-56 w-96 rounded-[28px] bg-sage/10 backdrop-blur-[2px] ring-1 ring-white/5"
      />

      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-10">
        <ChapterHeading
          index="10"
          eyebrow="Implementação"
          dark
          lines={["Do diagnóstico à ativação", "em poucos passos."]}
        />

        <div className="mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`impl-step-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -5 }}
              className="relative rounded-3xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur-sm transition-colors duration-300 hover:border-turquoise/50"
            >
              <span className="absolute right-6 top-5 font-display text-5xl font-extrabold text-white/[0.06]">
                0{i + 1}
              </span>
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-turquoise/15 text-turquoise">
                <s.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-6 font-display text-lg font-bold text-white">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-sage/75">{s.text}</p>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.25} className="mt-12">
          <p className="max-w-2xl text-base text-sage/80">
            <span className="font-semibold text-turquoise">Resultado:</span> um atendimento
            automatizado, configurado para a realidade do seu negócio — sem você precisar entender
            de tecnologia.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
